import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { avatar } from "../../assets/index";
import { heroQuips, profile } from "../../constants";

// The centre of the hero orbit: photo with a spinning gradient ring, a waving hand,
// and a speech bubble that cycles through playful one-liners.
const AvatarCore = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setIndex((i) => (i + 1) % heroQuips.length), 3200);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="relative flex flex-col items-center">
      <div className="absolute bottom-full mb-4 h-10 flex items-end justify-center">
        <AnimatePresence mode="wait">
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 10, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -8, scale: 0.95 }}
            transition={{ duration: 0.3 }}
            className="relative whitespace-nowrap px-4 py-2 rounded-2xl bg-white text-bodyColor text-xs lgl:text-sm font-semibold shadow-xl shadow-black/40"
          >
            {heroQuips[index]}
            <span className="absolute left-1/2 -bottom-1.5 -translate-x-1/2 w-3 h-3 rotate-45 bg-white"></span>
          </motion.div>
        </AnimatePresence>
      </div>

      <button
        onClick={() => setIndex((i) => (i + 1) % heroQuips.length)}
        aria-label="Show another fun fact"
        className="group relative w-36 h-36 lgl:w-48 lgl:h-48 rounded-full focus:outline-none"
      >
        <span className="orbit absolute -inset-[5px] rounded-full bg-[conic-gradient(from_0deg,#ff014f,#ff8a5c,#ffd36e,#ff8a5c,#ff014f)] [animation-duration:6s]"></span>
        <span className="absolute -inset-6 rounded-full bg-designColor/30 blur-2xl group-hover:bg-designColor/50 duration-500"></span>
        <img
          src={avatar}
          alt={profile.name}
          className="relative w-full h-full rounded-full object-cover border-4 border-bodyColor group-hover:scale-[1.03] duration-300"
        />
        <span className="wave absolute -right-1 bottom-2 text-3xl lgl:text-4xl drop-shadow-lg" aria-hidden>
          👋
        </span>
      </button>
    </div>
  );
};

export default AvatarCore;
